import Analytics from 'analytics';
import googleAnalytics from '@analytics/google-analytics';
import {appKey, gaId} from '../constants/app';

const plugins = [];
if (gaId) {
	plugins.push(
		googleAnalytics({
			measurementIds: [gaId],
			customDimensions: {},
		})
	);
}

const analytics = Analytics({
	app: appKey,
	plugins,
});

analytics.page();

export default analytics;
